import { render, staticRenderFns } from "./rule_list.vue?vue&type=template&id=036ca6fd&scoped=true"
import script from "./rule_list.vue?vue&type=script&lang=js"
export * from "./rule_list.vue?vue&type=script&lang=js"
import style0 from "./rule_list.vue?vue&type=style&index=0&id=036ca6fd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ca6fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036ca6fd')) {
      api.createRecord('036ca6fd', component.options)
    } else {
      api.reload('036ca6fd', component.options)
    }
    module.hot.accept("./rule_list.vue?vue&type=template&id=036ca6fd&scoped=true", function () {
      api.rerender('036ca6fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_rule/components/rule_list/rule_list.vue"
export default component.exports